import { lazy } from "react";

const PigLoader = lazy(() =>
  import("./pages/Offers/loaders/PigLoader" /* webpackChunkName: 'PigLoader' */)
);

export default {
  PigLoader
};
